import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GlobalErrorHandlerService } from './global-error-handler.service';

import { PrescriptionTemplate } from '../prescription-template/prescription-template';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class PrescriptionTemplateService {

  private prescriptionTemplatesUrl = 'api/prescription_templates';

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorHandlerService
  ) { }

  getPrescriptionTemplate(id: number): Observable<PrescriptionTemplate> {
    return this.http
      .get<PrescriptionTemplate>(`${this.prescriptionTemplatesUrl}/${id}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  searchPrescriptionTemplateByName(name: string): Observable<PrescriptionTemplate[]> {
    if (!name.trim()) { return of([]); }
    return this.http
      .get<PrescriptionTemplate[]>(`${this.prescriptionTemplatesUrl}/?name=${name}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  createPrescriptionTemplate(template: PrescriptionTemplate): Observable<PrescriptionTemplate> {
    return this.http
      .post<PrescriptionTemplate>(this.prescriptionTemplatesUrl, template, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  updatePrescriptionTemplate(template: PrescriptionTemplate): Observable<PrescriptionTemplate> {
    return this.http
    .patch<PrescriptionTemplate>(`${this.prescriptionTemplatesUrl}/${template.id}`, template, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  deletePrescriptionTemplate(id: number): Observable<PrescriptionTemplate> {
    return this.http
      .delete(`${this.prescriptionTemplatesUrl}/${id}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }
}
